import React from "react";
import "./MoreLikeThis.css";
import { Button, Typography, useMediaQuery } from "@mui/material";
import { useNavigate } from "react-router-dom";
import {
  MoreLikeThisBigButton,
  MoreLikeThisSmallButton,
  MLTLinks,
  MLTLoginButton,
} from "../../../../calculatorStyleData";

const MoreLikeThis = () => {
  const navigate = useNavigate();
  const isLargeScreen = useMediaQuery(" (max-width:992px) ");
  const isMediumScreen = useMediaQuery(" (max-width:768px) ");
  const isSmallScreen = useMediaQuery(" (max-width:576px) ");
  return (
    <>
      <div className="more_like_this mt-5">
        <div className="d-flex flex-column flex-sm-row align-items-start  align-items-sm-center gap-2">
          <Typography
            sx={{
              fontSize: 13,
              fontWeight: 600,
              lineHeight: "20px",
              letterSpacing: "0.48px",
              paddingRight: "15px",
            }}
          >
            MORE LIKE THIS
          </Typography>
          <div className="d-flex flex-row gap-2">
            <Button
              onClick={() => {
                navigate("/loanpage/homeloan");
              }}
              sx={MLTLinks}
            >
              Home Loans
            </Button>
            <Button
              onClick={() => {
                navigate("/loanpage/");
              }}
              sx={MLTLinks}
            >
              Loans
            </Button>
          </div>
        </div>
        <div className="more_like_this__buttons mt-4">
          <Button
            variant="contained"
            sx={MoreLikeThisBigButton}
            fullWidth
            onClick={() => {
              navigate("/calculators/emi-calculators/home-loan-emi-calculator");
            }}
          >
            <div className="button__card  gap-4 w-100 py-3 px-2">
              <img
                src="https://minemiwebsite.s3.ap-south-1.amazonaws.com/assets/home-loan-emi-1738049750722.webp"
                alt="wedding loan calculator"
                className="personal_loan_lender"
              />
              <div className="d-flex flex-column justify-content-between w-100">
                <div className="d-flex flex-column justify-content-start align-items-start gap-4">
                  <Typography
                    sx={{
                      fontSize: isSmallScreen
                        ? "24.6973px"
                        : isMediumScreen
                        ? "27.7064px"
                        : isLargeScreen
                        ? "29.4771px"
                        : "35.5597px",
                      lineHeight: isSmallScreen
                        ? "32.1216px"
                        : isMediumScreen
                        ? "34.6331px"
                        : isLargeScreen
                        ? "36.8464px"
                        : "44.4496px",
                      color: "#000",
                      letterSpacing: "0.04px",
                      textTransform: "none",
                      textAlign: "start",
                      fontFamily: "'Archivo',sans-serif",
                    }}
                  >
                    Home Loan EMI Calculator: Simplify Your Loan Planning
                  </Typography>
                  <Typography
                    sx={{
                      fontSize: 16,
                      lineHeight: "24px",
                      letterSpacing: "0.08px",
                      textAlign: "start",
                      color: "#000",
                      fontFamily: "'Archivo',sans-serif",
                      textTransform: "none",
                    }}
                  >
                    Understanding and planning your home loan EMI is critical to
                    managing your finances efficiently. With Minemi’s EMI
                    calculator, you can simulate your monthly payments, compare
                    different loan scenarios, and make informed decisions.
                    Whether you’re taking a new home loan or transferring an
                    existing one, this page is your guide to effective EMI
                    management
                  </Typography>
                </div>
                <div className="text-end">
                  <Button
                    sx={{
                      width: "10rem",
                      fontSize: 16,
                      lineHeight: "24px",
                      textTransform: "none",
                      fontFamily: "'Archivo',sans-serif",
                    }}
                    onClick={() => {
                      navigate(
                        "/calculators/emi-calculators/home-loan-emi-calculator"
                      );
                    }}
                  >
                    Read More
                  </Button>
                </div>
              </div>
            </div>
          </Button>
          <div className="d-flex flex-column flex-md-row gap-3 justify-content-between mt-3">
            <Button
              variant="contained"
              sx={MoreLikeThisSmallButton}
              fullWidth
              onClick={() => {
                navigate(
                  "/calculators/debt-consolidation-calculators/debt-consolidation-calculator"
                );
              }}
            >
              <div className="d-flex justify-content-start gap-4 w-100 py-3 px-2">
                <div className="d-flex flex-column justify-content-start gap-3 w-100">
                  <div className="d-flex flex-column justify-content-start align-items-start gap-3">
                    <Typography
                      sx={{
                        fontSize: isSmallScreen
                          ? "24.6973px"
                          : isMediumScreen
                          ? "27.7064px"
                          : isLargeScreen
                          ? "29.4771px"
                          : "35.5597px",
                        lineHeight: isSmallScreen
                          ? "32.1216px"
                          : isMediumScreen
                          ? "34.6331px"
                          : isLargeScreen
                          ? "36.8464px"
                          : "44.4496px",
                        color: "#000",
                        letterSpacing: "0.04px",
                        textTransform: "none",
                        textAlign: "start",
                        fontFamily: "'Archivo',sans-serif",
                      }}
                    >
                      Debt Consolidation Calculator: Simplify Your Repayments
                    </Typography>
                    <div className="d-flex align-items-center gap-2"></div>
                  </div>
                  <div>
                    <Typography
                      sx={{
                        fontSize: 16,
                        lineHeight: "24px",
                        letterSpacing: "0.08px",
                        textAlign: "start",
                        color: "#000",
                        fontFamily: "'Archivo',sans-serif",
                        textTransform: "none",
                      }}
                    >
                      Minemi’s Debt Consolidation Calculator simplifies multiple
                      debts into one manageable loan, reducing your EMI burden.
                    </Typography>
                  </div>
                </div>
              </div>
              <div className="text-end mb-2 w-100">
                <Button
                  onClick={() => {
                    navigate(
                      "/calculators/debt-consolidation-calculators/debt-consolidation-calculator"
                    );
                  }}
                  sx={{
                    fontSize: 16,
                    lineHeight: "24px",
                    textTransform: "none",
                    fontFamily: "'Archivo',sans-serif",
                  }}
                >
                  Read More
                </Button>
              </div>
            </Button>
            <Button
              variant="contained"
              sx={MoreLikeThisSmallButton}
              fullWidth
              onClick={() => {
                navigate("/loanpage/homeloan/how-much-loan-can-i-afford");
              }}
            >
              <div className="d-flex justify-content-start gap-4 w-100 py-3 px-2">
                <div className="d-flex flex-column justify-content-start gap-3 w-100">
                  <div className="d-flex flex-column justify-content-start align-items-start gap-3">
                    <Typography
                      sx={{
                        fontSize: isSmallScreen
                          ? "24.6973px"
                          : isMediumScreen
                          ? "27.7064px"
                          : isLargeScreen
                          ? "29.4771px"
                          : "35.5597px",
                        lineHeight: isSmallScreen
                          ? "32.1216px"
                          : isMediumScreen
                          ? "34.6331px"
                          : isLargeScreen
                          ? "36.8464px"
                          : "44.4496px",
                        color: "#000",
                        letterSpacing: "0.04px",
                        textTransform: "none",
                        textAlign: "start",
                        fontFamily: "'Archivo',sans-serif",
                      }}
                    >
                      How Much Loan Can I Afford?
                    </Typography>
                  </div>
                  <div>
                    <Typography
                      sx={{
                        fontSize: 16,
                        lineHeight: "24px",
                        letterSpacing: "0.08px",
                        textAlign: "start",
                        color: "#000",
                        fontFamily: "'Archivo',sans-serif",
                        textTransform: "none",
                      }}
                    >
                      Estimate how much you can borrow based on your income,
                      loan term, interest rate, and monthly expenses. This tool
                      helps you assess your loan affordability and make informed
                      borrowing decisions.
                    </Typography>
                  </div>
                </div>
              </div>
              <div className="text-end pb-0 mb-2 w-100">
                <Button
                  sx={{
                    fontSize: 16,
                    lineHeight: "24px",
                    textTransform: "none",
                    fontFamily: "'Archivo',sans-serif",
                  }}
                >
                  Read More
                </Button>
              </div>
            </Button>
          </div>
        </div>
        <div className="mt-4 d-flex justify-content-center">
          <div
            style={{
              width: isSmallScreen ? "90%" : "542px",
              height: isSmallScreen ? "auto" : "348px",
              border: "1px solid gray",
              borderRadius: "4px",
              backgroundColor: "#f4ecf9",
            }}
            className="d-flex flex-column align-items-center gap-3 p-3 "
          >
            <img
              src='/Assets/Images/email-verification.webp'
              alt="sign-up"
              style={{
                width: "7rem",
                height: "7rem",

                borderRadius: "50%",
              }}
            />
            <div className="px-3 text-center">
              <Typography
                sx={{
                  fontSize: 16,
                  fontWeight: 600,
                  lineHeight: "24px",
                  textAlign: "center",
                  color: "#000",
                  letterSpacing: "0.08px",
                  fontFamily: "'Archivo',sans-serif",
                }}
              >
                Unlock Financial Freedom – Straight to Your Inbox
              </Typography>
              <Typography
                sx={{
                  fontSize: 16,
                  fontWeight: 500,
                  lineHeight: "24px",
                  textAlign: "center",
                  color: "#000",
                  letterSpacing: "0.08px",
                  fontFamily: "'Archivo',sans-serif",
                }}
                className="mt-2"
              >
                Sign up now to receive expert tips, insights, and tools tailored
                to help you save more, reduce your EMIs, and manage your
                finances smarter. Empower your money decisions with Minemi.
              </Typography>
              <Button
                sx={MLTLoginButton}
                onClick={() => {
                  navigate("/login");
                }}
                className="mt-3"
              >
                Sign Up
              </Button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default MoreLikeThis;
